__webpack_require__.p = "https://bmidxbbulgariaplprod.netlify.app/";